import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isUploadingBusinessCustomer: false,
};

export const businesCustomerSlice = createSlice({
  name: "businesCustomer",
  initialState,
  reducers: {
    setUploadingGoals: (state, { payload }) => {
      state.isUploadingBusinessCustomer = payload;
    },
  },
});
export const businesCustomerActions = businesCustomerSlice.actions;

export default businesCustomerSlice.reducer;
